"use client";

import { POSTHOG_SIGNUP_PAGE_LOADED_EVENT } from "@/lib/posthog/identity";
import { useEffect } from "react";
import { usePostHog } from "posthog-js/react";

export function SignUpPageLoadTracker() {
  const posthog = usePostHog();

  useEffect(() => {
    posthog.capture(POSTHOG_SIGNUP_PAGE_LOADED_EVENT, {
      page: "sign_up",
    });
  }, [posthog]);

  return null;
}
